import './App.css';
import React from 'react';
import MainLayout from './Containers/MainLayout';
import { AuthContextProvider } from './Context/authContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './Utils/i18next/i18n.js';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppContextProvider } from './Context/appContext';
import { FormContextProvider } from './Context/formContext';
// import { Worker } from '@react-pdf-viewer/core';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { EntityContentProvider } from './Context/entityContext.js';
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { init, reactRouterV6BrowserTracingIntegration, replayIntegration } from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_PROJECTID, SENTRY_DSN } from './Constants/constant.js';
import GlobalThemeProvider from './Utils/themes/themeProvider.js';

try {
  init({
    dsn: SENTRY_DSN,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/apply\.smu\.edu\.in/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
} catch (error) {
  console.error('Sentry initialization error:', error);
}

try {
  // Mixpanel
  mixpanel.init(MIXPANEL_PROJECTID, {
    debug: true,
    track_pageview: true,
    persistence: 'localStorage',
    autocapture: {
      pageview: 'full-url',
      click: true,
      input: true,
      submit: true,
    },
  });
} catch (err) {
  console.error('Mixpanel initialization error', err);
}

function App() {
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <AppContextProvider>
          <FormContextProvider>
            <AuthContextProvider>
              <EntityContentProvider>
                <GlobalThemeProvider>
                  <I18nextProvider i18n={i18n}>
                    <div className="App">
                      <MainLayout />
                    </div>
                  </I18nextProvider>
                </GlobalThemeProvider>
              </EntityContentProvider>
            </AuthContextProvider>
          </FormContextProvider>
        </AppContextProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
}

export default App;
